import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from './pages/Dashboard.vue'
import Crypto from './pages/Crypto.vue'
import ThaiStocks from './pages/ThaiStocks.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/crypto',
      name: 'crypto',
      component: Crypto,
    },
    {
      path: '/thai-stocks',
      name: 'thai-stocks',
      component: ThaiStocks,
    },
  ],
})

export default router
